import {Injectable} from '@angular/core';
import {CustomPayout} from '../../models/custom-payout';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';

@Injectable({
  providedIn: 'root'
})
export class CustomPayoutService extends AbstractModelService<CustomPayout> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/custom-payout', CustomPayout);
  }
}
